<template>
  <div class="ossUpload">
    <el-upload
      class="avatar-uploader"
      :action="OSSInfo.host"
      :data="OSSInfo"
      :show-file-list="false"
      :on-success="handleAvatarSuccess"
      :before-upload="beforeAvatarUpload"
      :auto-upload="false"
      :on-change="changeUpload"
      :file-list="file_list"
    >
      <!-- :auto-upload="type=='4'" -->

      <img v-if="imageUrl && type == '11'" :src="imageUrl" class="cover" />
      <img v-else-if="imageUrl" :src="imageUrl" class="avatar" 
      />
      <div class="v_avatar-uploader_bottom" v-if="imageUrl && isChange!=undefined">更换封面</div>
      <div v-if="imageUrl==undefined || imageUrl==''" class="avatar-uploader-icon">
        <img v-if="isChange==undefined||isChange=='1'" src="@/assets/images/space/upload.png" /><br />
        <p v-if="isChange==undefined||isChange=='1'"><span>点击上传</span></p>
        <img v-if="isChange!=undefined&&isChange=='2'" class="iv_two" src="@/assets/images/space/upload_none.png" /><br />
        <p v-if="isChange!=undefined&&isChange=='2'" class="v_text_one"><span>暂未设置封面照片</span></p>
        <p v-if="isChange!=undefined&&isChange=='2'" class="v_text_two"><span>请</span><span class="v_text_three">点击上传</span></p>
      </div>
      <p v-show="type == '5'" class="avatar-uploader-btn">上传纪念堂封面</p>
    </el-upload>

    <!--    <el-upload
          class="avatar-uploader"
          action="123"
          :before-upload="beforeAvatarUpload"
        >xxxx
        </el-upload>-->
    <el-dialog
      class="dialog_cut_image"
      title="图片剪裁"
      width="86rem"
      :visible.sync="dialogVisible"
      append-to-body
    >
      <div class="cropper-content" style="height: 75rem">
        <div
          class="cropper"
          style="text-align: center; width: 65rem; height: 72rem; float: left"
        >
          <vueCropper
            ref="cropper"
            :img="option.img"
            :outputSize="option.size"
            :outputType="option.outputType"
            :info="true"
            :canMove="option.canMove"
            :canMoveBox="option.canMoveBox"
            :original="option.original"
            :autoCrop="option.autoCrop"
            :fixed="option.fixed"
            :centerBox="option.centerBox"
            :infoTrue="option.infoTrue"
            :fixedBox="option.fixedBox"
            :autoCropWidth="option.autoCropWidth"
            :autoCropHeight="option.autoCropHeight"
            :high="false"
          ></vueCropper>
        </div>
        <div
          class="size_btns"
          style="
            flex-direction: column;
            display: flex;
            float: left;
            margin-left: 40px;
          "
        >
          <el-button
            type="text"
            @click="changeSize(420, 560)"
            v-if="type == '1'"
            >420×560</el-button
          >
          <el-button
            type="text"
            @click="changeSize(285, 380)"
            v-if="type == '11'"
            >285×380</el-button
          >
          <el-button
            type="text"
            @click="changeSize(530, 620)"
            v-if="type == '2'"
            :style="file.wh == '530*620' ? 'color:#409EFF;' : 'color:#000000;'"
            >530x620</el-button
          >
          <el-button
            type="text"
            @click="changeSize(625, 415)"
            v-if="type == '2'"
            :style="file.wh == '625*415' ? 'color:#409EFF;' : 'color:#000000;'"
            >625x415</el-button
          >
          <el-button
            type="text"
            @click="changeSize(520, 700)"
            v-if="type == '2'"
            :style="file.wh == '520*700' ? 'color:#409EFF;' : 'color:#000000;'"
            >520x700</el-button
          >
          <el-button
            type="text"
            @click="changeSize(640, 480)"
            v-if="type == '3' || type == '5'"
            >640x480</el-button
          >
          <el-button
            type="text"
            @click="changeSize(325, 325)"
            v-if="type == '8'"
            >325x325</el-button
          >
          <el-button
            type="primary"
            @click="finish"
            style="width: 100px; margin-top: 30px"
            :disabled="loading"
            >确认</el-button
          >
          <el-button
            @click="dialogVisible = false"
            style="width: 100px; margin-top: 30px"
            >取 消</el-button
          >
        </div>
      </div>
      <!-- <div slot="footer" class="dialog-footer">
        <div style="text-align:center;">
        

        </div>
      </div> -->
    </el-dialog>
  </div>
</template>

<script>
import mixin from "./Mixins";
import { _getOSSsignature } from "@/api/Common";
import axios from "axios";
import { catchErr, updataLink } from "@/utils/utils";
export default {
  mixins: [mixin],
  // type : 11 分享封面
  props: ["type", "imageUrl", "dmId", "memorySize", "memorySizeAll", "isChange"],
  data() {
    return {
      file: {
        name: "",
        url: "",
        wh: "",
      },
      fileinfo: "",
      dialogVisible: false,
      // 裁剪组件的基础配置option
      option: {
        img: "", // 裁剪图片的地址
        info: true, // 裁剪框的大小信息
        outputSize: 0.8, // 裁剪生成图片的质量
        outputType: "jpeg", // 裁剪生成图片的格式
        canScale: false, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 300, // 默认生成截图框宽度
        autoCropHeight: 100, // 默认生成截图框高度
        fixedBox: true, // 固定截图框大小 不允许改变
        fixed: false, // 是否开启截图框宽高固定比例
        fixedNumber: [7, 5], // 截图框的宽高比例
        full: true, // 是否输出原图比例的截图
        canMoveBox: false, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: false, // 截图框是否被限制在图片里面
        infoTrue: true, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
      },
      file_list: [], //页面显示的数组
      // 防止重复提交
      loading: false,
      loadingAll: "",
      fileList: [],
    };
  },
  computed: {
    OSSInfo(file) {
      let { accessid, dir } = this.Common.OSSINFO;
      return {
        ...this.Common.OSSINFO,
        ossaccessKeyId: accessid,
        key: dir + "/" + this.file.name,
      };
      // "_${filename}"
    },
  },
  watch: {
    dialogVisible(v) {
      if (v) {
        this.loading = false;
        if (this.type == "1") {
          this.option.autoCropWidth = 420;
          this.option.autoCropHeight = 560;
          this.file.wh = "420*560";
        } else if (this.type == "11") {
          this.option.autoCropWidth = 285;
          this.option.autoCropHeight = 380;
          this.file.wh = "285*380";
        } else if (this.type == "2") {
          this.option.autoCropWidth = 530;
          this.option.autoCropHeight = 620;
          this.file.wh = "530*620";
        } else if (this.type == "3" || this.type == "5") {
          this.option.autoCropWidth = 640;
          this.option.autoCropHeight = 480;
          this.file.wh = "640*480";
        }else if (this.type == "8") {
          this.option.autoCropWidth = 325;
          this.option.autoCropHeight = 325;
          this.file.wh = "325*325";
        }
      } else {
        this.loading = false;
      }
    },
  },
  methods: {
    handleAvatarSuccess(res, file, fileList) {
      this.file.url =
        this.OSSInfo.host +
        "/" +
        this.OSSInfo.key.replace("${filename}", file.name);

      this.$emit("fileInfo", this.file);
    },

    beforeAvatarUpload(file) {
      debugger
      var timestamp = new Date().getTime();
      for (var i = 0; i < 6; i++) {
        timestamp += Math.floor(Math.random() * 10);
      }
      let arr = file.name.split(".");
      timestamp = timestamp + "." + arr[arr.length - 1];
      this.file = {
        name: timestamp,
        url: "",
        wh: "",
      };
      const isPic = file.type == "image/jpeg" || file.type == "image/png";
      const isMp4 = file.type == "video/mp4";
      const isPicSize = file.size / 1024 >= 10 && file.size / 1024 <= 1024;
      const isVideoSize =
        file.size / 1024 >= 1024 * 1 && file.size / 1024 <= 1024 * 40;

      if (this.type == "4") {
        if (!isMp4) {
          this.$message.error("上传视频格式限制为mp4");
          return false;
        }
        if (!isVideoSize) {
          this.$message.error("上传视频大小限制为1~40MB");
          return false;
        }
      } else {
        if (!isPic) {
          this.$message.error("上传照片格式限制为jpg或png");
          return false;
        }
        if (!isPicSize) {
          this.$message.error("上传照片大小限制为10KB~1MB");
          return false;
        }
      }

      return new Promise((resolve, reject) => {
        //判断尺寸
        this.getSize(file)
          .then((res) => {
            if (res) {
              //获取签名
              this.getData()
                .then((res) => {
                  if (res) {
                    this.$emit("fileInfoLoading", this.type, this.file.name);
                    resolve(true);
                  } else {
                    reject(false);
                  }
                })
                .catch((err) => {
                  reject(false);
                });
            } else {
              reject(false);
            }
          })
          .catch((err) => {
            reject(false);
          });
      });
    },

    getSize(file) {
      if (this.type == "4") {
        return this.getVideoSize(file);
      } else {
        return this.getImgSize(file);
      }
    },

    getImgSize(file) {
      let _that = this;
      return new Promise((resolve, reject) => {
        let _URL = window.URL || window.webkitURL;
        let image = new Image();
        image.onload = function () {
          let valid = false;
          let width = image.width;
          let height = image.height;
          if (_that.type == "1") {
            if (width == 420 && height == 560) {
              _that.file.wh = width + "*" + height;
              valid = true;
            } else {
              _that.$message.error("上传图片尺寸要求为420×560");
            }
          } else if (_that.type == "11") {
            if (width == 285 && height == 380) {
              _that.file.wh = width + "*" + height;
              valid = true;
            } else {
              _that.$message.error("上传图片尺寸要求为285×380");
            }
          } else if (_that.type == "2") {
            if (
              (width == 530 && height == 620) ||
              (width == 625 && height == 415) ||
              (width == 520 && height == 700)
            ) {
              _that.file.wh = width + "*" + height;
              valid = true;
            } else {
              _that.$message.error(
                "上传图片尺寸要求为530×620、625×415、520×700"
              );
            }
          } else if (_that.type == "3" || _that.type == "5") {
            if (width == 640 && height == 480) {
              _that.file.wh = width + "*" + height;
              valid = true;
            } else {
              _that.$message.error("上传图片尺寸要求为640×480");
            }
          }else if (_that.type == "8") {
            if (width == 325 && height == 325) {
              _that.file.wh = width + "*" + height;
              valid = true;
            } else {
              _that.$message.error("上传图片尺寸要求为325×325");
            }
          }
          valid ? resolve(true) : reject(false);
        };
        image.src = _URL.createObjectURL(file);
      });
    },

    getVideoSize(file) {
      let _that = this;
      return new Promise((resolve, reject) => {
        let _URL = window.URL || window.webkitURL;
        let videoElement = document.createElement("video");
        videoElement.addEventListener("loadedmetadata", function (_event) {
          let valid = true;
          let width = videoElement.videoWidth;
          let height = videoElement.videoHeight;
          let duration = videoElement.duration; // 视频时长
          //if(!isLt30MB) return operatTip('error','上传视频大小不能超过30MB！')
          //if(Math.floor(duration) >= 30) return operatTip('error','上传视频时长不能超过 30S！')
          if (width == 640 && height == 480) {
            _that.file.wh = width + "*" + height;
          } else {
            valid = false;
            _that.$message.error("上传视频尺寸要求为640×480");
          }
          valid ? resolve(true) : reject(false);
        });
        videoElement.src = _URL.createObjectURL(file);
      });
    },

    async getData() {
      if (this.type == "3" || this.type == "4" || this.type == "5") {
        return await this.getOSSsignature("custom");
      } else if (this.type == "11") {
        return await this.getOSSsignature("deadMan/photo");
      } else {
        return await this.getOSSsignature("deadMan");
      }
    },

    // 上传按钮   限制图片大小
    changeUpload(file, fileList) {
      console.log(file);
      // if (this.type == "7") {
      //   const isLt5M = file.size / 1024 / 1024 < 10 && file.size / 1024 > 10;
      //   if (!isLt5M) {
      //     this.$message.error("本次上传失败，上传图片大小限制为10KB~10MB");
      //     return false;
      //   }
      // } else {
        const isLt5M = file.size / 1024 / 1024 < 10 && file.size / 1024 > 10;
        if (!isLt5M) {
          this.$message.error("本次上传失败，上传图片大小限制为10KB~10MB");
          return false;
        }
      //}

      const isPic =
        file.raw.type == "image/jpeg" || file.raw.type == "image/png";
      if (!isPic) {
        this.$message.error("本次上传失败，上传图片必须为jpg或png格式");
        return false;
      }

      if (this.memorySize != undefined) {
        let fileBig = this.memorySize + file.size / 1024;
        if (fileBig > this.memorySizeAll) {
          this.$message.error("文件大小超出纪念堂剩余大小，请重新选择文件");
          return false;
        } else {
          this.SpaceManagement.spaceDetails.details.fileSizeUse = fileBig;
        }
      }

      this.fileinfo = file;

      if (this.type == "7") {
        console.log(this.fileinfo);
        this.toAnother(3);
        return;
      }

      //第二种方法，URL.createObjectURL接收file类型
      this.$nextTick(() => {
        this.option.img = URL.createObjectURL(file.raw);
        this.dialogVisible = true;
      });
    },
    changeSize(width, height) {
      this.option.autoCropWidth = width;
      this.option.autoCropHeight = height;
      this.file.wh = width + "*" + height;
    },
    getPath(isArtworkMaster) {
      if (isArtworkMaster == 1) {
        //原图
        if (this.dmId != undefined) {
          return `${updataLink()}space/${this.dmId}/yesterday/sye_server_`;
        } else {
          return `${updataLink()}space/yesterday/sye_server_`;
        }
      } else if (isArtworkMaster == 2) {
        //截图
        if (this.type == "3" || this.type == "4" || this.type == "5") {
          return "custom";
        } else if (this.type == "11") {
          //纪念堂封面
          if (this.dmId != undefined) {
            return `${updataLink()}space/${this.dmId}/cover/sco_server_`;
          } else {
            return `${updataLink()}space/cover/sco_server_`;
          }
        } else if (this.type == "2") {
          //相册
          if (this.dmId != undefined) {
            return `${updataLink()}space/${this.dmId}/photo/sph_server_`;
          } else {
            return `${updataLink()}space/photo/sph_server_`;
          }
        } else if (this.type == "8") {
          //空间往昔封面
          if (this.dmId != undefined) {
            return `${updataLink()}space/${this.dmId}/yesterdayCover/syec_ `;
          } else {
            return `${updataLink()}space/yesterdayCover/syec_ `;
          }
        } else {
          return "deadMan";
        }
      } else if (isArtworkMaster == 3) {
        //企业微信二维码
        return "admin/aca_";
      }
    },
    async getNewFile() {
      // 获取截图的blob数据
      return new Promise((resolve, reject) => {
        this.$refs.cropper.getCropBlob((data) => {
          let oldFile = this.fileinfo.raw;
          console.log(data);
          let newFile = data;
          newFile.name = oldFile.name;
          resolve(newFile);
        });
      });
    },
    // 点击裁剪，这一步是可以拿到处理后的地址
    async finish() {
      // this.fileList = []

      let file = await this.getNewFile();
      // let file = this.fileinfo.raw;
      var timestamp = new Date().getTime();
      for (var i = 0; i < 6; i++) {
        timestamp += Math.floor(Math.random() * 10);
      }
      let arr = file.name.split(".");
      timestamp = timestamp + "." + arr[arr.length - 1];
      this.file.name = timestamp;

      const isPic = file.type == "image/jpeg" || file.type == "image/png";
      // const isPicSize = file.size / 1024 >= 10 && file.size / 1024 <= 1024;

      if (!isPic) {
        this.$message.error("上传照片格式限制为jpg或png");
        return false;
      }
      // if (!isPicSize) {
      //   this.$message.error("上传照片大小限制为10KB~1MB");
      //   return false;
      // }
      this.loading = true;

      this.loadingAll = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      //判断尺寸
      let [err, res] = await catchErr(
        _getOSSsignature({
          data: this.getPath(2),
        })
      );
      if (res && res.status == 1000) {
        let resData = res.data;

        let uploadData = {};

        uploadData.dir = resData.dir;
        uploadData.host = resData.host;
        uploadData.ossaccessKeyId = resData.accessid;
        uploadData.policy = resData.policy;
        uploadData.signature = resData.signature;
        let fileName = resData.dir + timestamp;

        uploadData.key = fileName;

        //创建 formData 对象
        let formData = new FormData();
        //多个文件上传
        formData.append("dir", resData.dir);
        formData.append("host", resData.host);
        formData.append("ossaccessKeyId", resData.accessid);
        formData.append("policy", resData.policy);
        formData.append("signature", resData.signature);
        formData.append("key", fileName);
        formData.append("file", file);
        axios({
          method: "post",
          url: resData.host,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          data: formData, // 直接提交转换后的数据即可
        })
          .then((res) => {
            this.file.url = resData.host + "/" + fileName;
            this.file.size = file.size;
            console.log(this.file);
            this.fileList = [];
            this.fileList.push(this.file);

            // setTimeout(()=>{
            //   this.toAnother(1);
            // },1000)
            this.toCheckUpdateCover("");
          })
          .catch((err) => {
            this.loading = false;
            this.loadingAll.close();
            console.log(err);
          });
      } else {
        this.loading = false;
        this.loadingAll.close();
        this.$message("上传失败");
      }

      // this.$refs.cropper.getCropBlob((data) => {

      // });
    },

    async toAnother(number) {
      //继续上传原图
      var timestamp = new Date().getTime();
      for (var i = 0; i < 6; i++) {
        timestamp += Math.floor(Math.random() * 10);
      }
      let arr = this.fileinfo.name.split(".");
      timestamp = timestamp + "." + arr[arr.length - 1];
      this.fileinfo.name = timestamp;

      let [err, res] = await catchErr(
        _getOSSsignature({
          data: this.getPath(number),
        })
      );

      if (res && res.status == 1000) {
        let resData = res.data;

        let uploadData = {};

        uploadData.dir = resData.dir;
        uploadData.host = resData.host;
        uploadData.ossaccessKeyId = resData.accessid;
        uploadData.policy = resData.policy;
        uploadData.signature = resData.signature;
        let fileName = resData.dir + timestamp;

        uploadData.key = fileName;

        //创建 formData 对象
        let formData = new FormData();
        //多个文件上传
        formData.append("dir", resData.dir);
        formData.append("host", resData.host);
        formData.append("ossaccessKeyId", resData.accessid);
        formData.append("policy", resData.policy);
        formData.append("signature", resData.signature);
        formData.append("key", fileName);
        formData.append("file", this.fileinfo.raw);

        axios({
          method: "post",
          url: resData.host,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          data: formData, // 直接提交转换后的数据即可
        })
          .then((resd) => {
            this.fileinfo.url = resData.host + "/" + fileName;
            if (this.type == "7") {
              this.$emit("fileInfoA", this.fileinfo);
            } else {
              this.fileList.push(this.fileinfo);
              this.toCheckUpdateCover(this.fileinfo.url);
            }
          })
          .catch((err) => {
            if (this.type != "7") {
              this.loading = false;
              this.loadingAll.close();
            }
            console.log(err);
          });
      } else {
        if (this.type != "7") {
          this.loading = false;
          this.loadingAll.close();
        }
        this.$message("上传失败");
      }
    },

    //检测纪念堂封面原图
    toCheckUpdateCover(url) {
      this.loading = false;
      this.loadingAll.close();
      this.dialogVisible = false;
      this.$emit("fileInfo", this.fileList);
      return;
      setTimeout(() => {
        this.getOssFileState(url).then((res) => {
          console.log(res);
          if (res.status == 1000) {
            if (res.data == 0) {
              this.toCheckUpdateCover(url);
            } else if (res.data == 1) {
              //失败
              this.loading = false;
              this.loadingAll.close();
              this.dialogVisible = false;
              this.$message.error("内容存在潜在风险，操作失败，请重新操作");
            } else if (res.data == 2) {
              //成功
              this.loading = false;
              this.loadingAll.close();
              this.dialogVisible = false;
              this.$emit("fileInfo", this.fileList);
            }
          } else {
            //接口失败
            this.loading = false;
            this.loadingAll.close();
            this.dialogVisible = false;
          }
        });
      }, 3000);
    },
  },
};
</script>
<style lang="stylus" scoped>
.size_btns {
  .el-button {
    margin-left: 0;
  }
}
</style>

<style lang="stylus">
.ossUpload {
  .avatar-uploader-btn {
    position: absolute;
    bottom: 0;
    height: 34px;
    width: 200px;
    line-height: 34px;
    font-size: 12px;
    font-weight: 400;
    color: #fff;
    background-color: #3A81FF;
  }

  .cropper-content {
    .cropper {
      width: auto;
      height: 300px;
    }
  }
}

.dialog_cut_image .el-dialog__header {
  padding: 10px 0;
  border-bottom: 1px solid #e6e6e6;
  text-indent: 30px;
  height: 50px;
  line-height: 50px;

  .el-dialog__title {
    font-size: 34px;
    font-weight: 500;
    color: #000;
    line-height: 60px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/OSSUpload.vue